import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyRound, AlertCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

// Login do aluno: só o código de 6 dígitos que a equipe entrega (sem e-mail/
// senha — ver POST /api/auth/aluno-login no backend, e o botão "Gerar Código
// de Acesso" em GerenciarMatriculas.js, de onde a equipe pega o código).
function AlunoLogin() {
  const navigate = useNavigate();
  const { loginAluno } = useAuth();
  const [codigo, setCodigo] = useState('');
  const [erro, setErro] = useState('');
  const [entrando, setEntrando] = useState(false);

  const onCodigoChange = (e) => {
    const somenteDigitos = e.target.value.replace(/\D/g, '').slice(0, 6);
    setCodigo(somenteDigitos);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (codigo.length !== 6) {
      setErro('Digite os 6 números do seu código.');
      return;
    }
    setErro('');
    setEntrando(true);
    try {
      await loginAluno(codigo);
      navigate('/aluno/perfil', { replace: true });
    } catch (error) {
      setErro(error.response?.data?.error || 'Código inválido. Confira e tente de novo.');
    } finally {
      setEntrando(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#F9FAFB] to-[#E5E7EB] dark:from-gray-950 dark:to-gray-900 p-4">
      <div className="w-full max-w-sm bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl rounded-3xl border border-white/50 dark:border-gray-800/50 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1)] p-6">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.svg" alt="Portal Novas Histórias" className="w-16 h-auto object-contain mb-4" />
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 tracking-tight">
            Minha Presença
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 text-center">
            Digite o código que você recebeu da sua unidade
          </p>
        </div>

        {erro && (
          <div className="flex items-start gap-2 p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900/40 text-red-600 dark:text-red-400 text-sm mb-4">
            <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span>{erro}</span>
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-5">
          <div className="relative">
            <KeyRound className="w-5 h-5 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" />
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              value={codigo}
              onChange={onCodigoChange}
              placeholder="000000"
              autoFocus
              className="w-full h-16 pl-12 pr-4 rounded-2xl border-2 border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-center text-3xl font-bold tracking-[0.5em] text-gray-900 dark:text-gray-100 placeholder:text-gray-300 dark:placeholder:text-gray-600 focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
            />
          </div>

          <button
            type="submit"
            disabled={entrando || codigo.length !== 6}
            className="w-full h-12 rounded-2xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {entrando ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Entrando...
              </>
            ) : (
              'Entrar'
            )}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-gray-400 dark:text-gray-500">
          Não tem um código? Peça pra sua unidade gerar um pra você.
        </p>
      </div>
    </div>
  );
}

export default AlunoLogin;
